export const theme = {
  colors: {
    background: "#071b15",
    panel: "#10281f",
    panelLight: "#19352a",
    deep: "#06120e",
    text: "#f0eee3",
    muted: "#b2beb4",
    gold: "#e8cd73",
    goldDim: "#a18d4f",
    line: "#395044",
    green: "#a9e7a1",
    red: "#ffaca1",
  },
  font: {
    display: '"Barlow Condensed", "Arial Narrow", Impact, sans-serif',
    body: '"Inter", "Segoe UI", Arial, sans-serif',
  },
  radius: { card: "0", control: "0", pill: "0" },
  width: "1180px",
  shadow: "none",
} as const;

export type SiteTheme = typeof theme;
